import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";
import { useAlert } from "react-alert";

function AdminSearchStripeSubs({ adminType }) {
  const alert = useAlert();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  const handleSearch = async () => {
    try {
      if (searchMail) {
        let payload = {
          email: searchMail,
        };
        setLoader(true);
        const res = await api.getStripeSubsByAdmin(payload);
        // console.log(res);
        if (res?.subscription) {
          setData(res?.subscription);
          setLoader(false);
        } else {
          alert.info(res.message || "Subscription does not exist");
          setLoader(false);
        }
      } else {
        alert.info("Please insert email for search");
      }
    } catch (error) {
      alert.error("Invalid Email Address");
      setLoader(false);
    }
  };

  useEffect(() => {
    if (searchMail) {
      handleSearch();
    }
  }, [page]);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top left corner
  }, []);

  const formatDate = (date) => {
    const stampToDate = new Date(date * 1000);
    let dateTemp = moment(stampToDate).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="payHistoryPage">
          <div className="row">
            {/* Area Chart */}
            <div className="col">
              <div className="row mx-0 drivers-row">
                <div className="col-12   d-flex justify-content-between pr-0 flex-wrap">
                  <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                    Search User Stripe
                    {/* ({noOfUser}) */}
                  </h4>
                  {/* <a href="#" className="driver-row-link">All</a>
                                 <a href="#" className="driver-row-link">Arbitrators (86)</a>
                                 <a href="#" className="driver-row-link">Mediators (32)</a> */}
                  <div className="searchMadmin">
                    <div className="title">Search: </div>
                    <div className="inputM">
                      <input
                        onChange={(e) => setSearchMail(e.target.value)}
                        type="email"
                        placeholder="Search by email..."
                      />
                      <i
                        className="fa-solid fa-magnifying-glass"
                        onClick={handleSearch}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mx-0">
                <div className="col-12">
                  <div className="stripeSubsMain">
                    {data?.status && (
                      <div className="dataRow">
                        <div className="title">
                          Status:{" "}
                          <span
                            className={
                              data?.status == "inactive"
                                ? "badge active"
                                : "badge inactive"
                            }
                          >
                            {data?.status}
                          </span>
                        </div>
                        <div className="title">
                          Period Start:{" "}
                          <span>
                            {data?.current_period_start
                              ? formatDate(data?.current_period_start)
                              : ""}
                          </span>
                        </div>
                        <div className="title">
                          Status End:{" "}
                          <span>
                            {data?.current_period_start
                              ? formatDate(data?.current_period_end)
                              : ""}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}

export default AdminSearchStripeSubs;
